var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"mt-2 custom-card-header-text"},[_vm._v("Member Rank Report")])]),_c('h4',{staticClass:"text-center"},[_vm._v("Please wait...")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }